/*
 * Copyright (c) Outright Mental (https://outrightmental.com/) All Rights Reserved.
 */

// vendor
import React from "react";
// app
import "./DashProgress.scss"
import {toRgbString} from "../../util";

/**
 DashProgress component renders the given content with a background progress indicator bar
 <p>
 @return {*}
 @param {{
   children: Object,
   progress: Number,
   backgroundColor: String,
   barBackgroundColor: String
 }} props for this component
 */
export default function DashProgress(props) {
  const
    progress = props.progress, // ratio between 0.0 and 1.0
    backgroundColor = props.backgroundColor,
    barBackgroundColor = props.barBackgroundColor;

  return (
    <div className="progress-indicator" style={{backgroundColor}}>
      <div className="progress-container">
        <div className="progress-content">{props.children}</div>
        <div className="progress-bar" style={{
          backgroundColor: barBackgroundColor,
          width: `${Math.floor(100 * progress)}%`
        }}>&nbsp;</div>
      </div>
    </div>
  );
};
